import DetailSetUpReverseProxy from "../../../../contents/docs/integrate/_snippets/details/set-up-reverse-proxy.mdx";
import DetailGroupProductsInOneProject from "../../../../contents/docs/integrate/_snippets/details/group-products-in-one-project.mdx";
import DetailPostHogIPs from "../../../../contents/docs/integrate/_snippets/details/posthog-ips.mdx";
import AgentIntegrationSection from "../../../../contents/docs/components/AgentIntegrationSection.mdx";
import ReactInstall from "../../../../contents/docs/integrate/_snippets/install-react.mdx";
import FeatureFlagsLibsIntro from "../../../../contents/docs/libraries/_snippets/feature-flags-libs-intro.mdx";
import ReactFeatureFlagsCode from "../../../../contents/docs/integrate/feature-flags-code/_snippets/feature-flags-code-react.mdx";
import BootstrappingIntro from "../../../../contents/docs/feature-flags/snippets/bootstrapping-intro.mdx";
import * as React from 'react';
export default {
  DetailSetUpReverseProxy,
  DetailGroupProductsInOneProject,
  DetailPostHogIPs,
  AgentIntegrationSection,
  ReactInstall,
  FeatureFlagsLibsIntro,
  ReactFeatureFlagsCode,
  BootstrappingIntro,
  React
};